import React from "react";
import styled from "styled-components";

const Container = styled.div`
  padding: 10px;
  background: #cecee6;
  text-align: center;
`;

const Footer = () => {
  return (
    <Container>
      <section>
        © Fixpert Computer Systems | {`${new Date().getFullYear()}`}
      </section>
    </Container>
  );
};

export default Footer;
